import type { Me } from '../api';

const PENDING_KEY = (userId: string) => `physioedge.wasPending:${userId}`;
const SEEN_KEY = (userId: string) => `physioedge.approvedWelcomeSeen:${userId}`;
/** First login after approval still counts if they never opened the site while pending. */
const JUST_APPROVED_MS = 14 * 24 * 60 * 60 * 1000;

const listeners = new Set<() => void>();
let dialogOpen = false;

function notify() {
  listeners.forEach(fn => fn());
}

export function subscribeApprovedWelcomeHold(fn: () => void) {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

export function noteStudentPending(userId: string) {
  try { localStorage.setItem(PENDING_KEY(userId), '1'); } catch { /* ignore */ }
}

export function markApprovedWelcomeSeen(userId: string) {
  try {
    localStorage.setItem(SEEN_KEY(userId), '1');
    localStorage.removeItem(PENDING_KEY(userId));
  } catch { /* ignore */ }
}

function welcomeAlreadySeen(userId: string) {
  try { return localStorage.getItem(SEEN_KEY(userId)) === '1'; } catch { return false; }
}

function wasPendingHere(userId: string) {
  try { return localStorage.getItem(PENDING_KEY(userId)) === '1'; } catch { return false; }
}

function justApproved(approvedAt?: string | null) {
  if (!approvedAt) return false;
  const at = Date.parse(approvedAt);
  if (Number.isNaN(at)) return false;
  const age = Date.now() - at;
  return age >= 0 && age <= JUST_APPROVED_MS;
}

export function approvedWelcomeShouldShow(me: Me | null | undefined): boolean {
  if (!me?.id || me.role !== 'student' || me.approvalStatus !== 'approved') return false;
  if (welcomeAlreadySeen(me.id)) return false;
  return wasPendingHere(me.id) || justApproved(me.approvedAt);
}

export function setApprovedWelcomeDialogOpen(open: boolean) {
  if (dialogOpen === open) return;
  dialogOpen = open;
  notify();
}

export function approvedWelcomeHoldsOffer(me: Me | null | undefined): boolean {
  return dialogOpen || approvedWelcomeShouldShow(me);
}
